import palette from "./palette";

export default {
    title: {
        fontSize: 72,
        fontWeight: 600
    },
    subTitle: {
        fontSize: 40,
        fontWeight: 600
    },
    small: {
        fontSize: 12,
        color: palette.text.small
    },
    tooltip: {
        fontWeight: "bold",
    }
};